import * as yup from 'yup';
import { escrowFields } from './EscrowSchema';

export function escrowAdjustmentFormSchema() {
  const fields = escrowFields();
  fields.escrowAmount = fields.escrowAmount.label('Escrow Adjustment');

  return yup.object(fields);
}

export function escrowAdjustmentGridSchema() {
  return escrowAdjustmentFormSchema();
}
